export default class VehicleService {
  constructor($http, appConfig) {
    "ngInject";

    this.$http = $http;
    this.appConfig = appConfig;
  }

  getVehicle(entityId, vehicleId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/vehicle/get/${entityId}/${vehicleId}`);
  }

  getVehicleAppraisal(entityId, vehicleId, enquiryId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/vehicle/get/appraisal/${entityId}/${vehicleId}/${enquiryId ? enquiryId : null}`);
  }

  editVehicle(vehicle) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/vehicle/add', vehicle);
  }

  editVehicleAppraisal(contactId, enquiryId, vehicleAppraisal) {
    //return this.$http.post(this.appConfig.apiServiceBaseUri + `api/vehicle/addappraisal/${contactId ? contactId : null}/${enquiryId ? enquiryId : null}`, vehicleAppraisal);
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/vehicle/addappraisal/${contactId ? contactId : '0'}/${enquiryId ? enquiryId : '0'}`, vehicleAppraisal);
  }

  listVehicles(filterParams) {
    let query = this.getQueryParams(filterParams);

    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/vehicle/list' + query);
  }

  getQueryParams(filterParams) {
    let query = '';

    query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
    query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
    query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
    query += `&ascending=${filterParams.pageCriteria.ascending}`;

    query += `&entityId=${filterParams.entityId}`;
    query += `&condition=${filterParams.vehicleConditionSearch.id}`;
    query += `&registration=${filterParams.registration || ''}`;

    /*
    * Check if selected brand is 0
    * this means that User is only allowed to see certain brands in new category
    * in which case send the allowed brandIds
    */
    if (filterParams.brand.brandId === 0) {
      query += `&brandIds=${filterParams.allowedBrands.map(b => b.brandId)}`;
    }
    else {
      /*
      * In this case it is either that User is Viewing old vehicles
      * which means it will be All brands with brandId = 1
      * or the User has wished to see a specific brand
      */
      query += `&brandIds=${filterParams.brand.brandId}`;
    }

    if (filterParams.brandModel.brandModelId !== 0) {
      query += `&modelId=${filterParams.brandModel.brandModelId}`;
    }

    if (filterParams.vehicleStatus.id) {
      query += `&state=${filterParams.vehicleStatus.id}`;
    }

    return query;
  }

  updateVehicleState(entityId, vehicleId, state) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/vehicle/update/${entityId}/${vehicleId}/${state}`);
  }

  publishToWeb(entityId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/vehicle/publish/${entityId}`);
  }

  easierAd(locationId) {
    const tokenRequest = {
      method: 'POST',
      url: `http://www.easierad.ie/admin/thirdparty/api/edit?dpid=${locationId}`,
      headers: {
        'Authorization': 'Basic Y2Fyc25vd2RwOlIkbWYyMzRlZWbCo2RkIQ=='
      },
    }

    this.$http(tokenRequest)
      .then(response => {
      })
      .catch(err => {
      });
  }

  searchVehicles(entityId, criteria) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/vehicle/search/${entityId}`, criteria);
  }

  annotateImage(height, width, imageBase, imgData) {
    return this.$http.post(this.appConfig.apiServiceBaseUri + `api/file/annotateImage/${height}/${width}/${imageBase}`, imgData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded'}  });
  }

  listDeliveredVehicles(filterParams) {
    let query = '';

    query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
    query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
    query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
    query += `&ascending=${filterParams.pageCriteria.ascending}`;

    query += `&entityId=${filterParams.entityId}`;

    query += `&startDate=${filterParams.startDate.toUniversalFormat()}`;
    query += `&endDate=${filterParams.endDate.toUniversalFormat()}`;

    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/vehicle/list/delivered' + query);
  }

  locationVehicles(entityId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/vehicle/locationvehicles/' + entityId);
  }

  createFromPriceList(entityId, priceListId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/vehicle/createfrompricelist/${entityId}/${priceListId}`);
  }
}



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicle.service.js